import { TWidget } from 'widgets/Widget';

/**
 * @description Base ProductStickyPanel implementation
 * @param Widget Base widget for extending
 * @returns Sticky panel widget
 */
function ProductStickyPanelClassCreator(Widget: TWidget) {
    /**
     * @class ProductStickyPanel
     * @augments Widget
     * @classdesc Represents product sticky panel component
     * Allows user adds a product to the cart from the sticky panel in case the user has scrolled down and
     * the main "Add to Cart" button is not in the user's viewport.
     * @property {string} data-widget - Widget name `productStickyPanel`
     */
    class ProductStickyPanel extends Widget {
        prefs() {
            return {
                classesOpened: 'm-opened',
                classesStickyPanel: 'm-sticky_panel',
                ...super.prefs()
            };
        }

        init() {
            this.emit('initobserver');

            this.eventBus().on('product.addTocart.intersects.viewport', 'togglePanel');
        }

        /**
         * @description Toggle class on product sticky panel to show/hide it
         * @param isShown - boolean value, witch tell the function remove or add class
         */
        togglePanel(isShown: boolean) {
            this.ref('self').toggleClass(this.prefs().classesOpened, isShown);
            document.body.classList.toggle(this.prefs().classesStickyPanel, isShown);
        }
    }

    return ProductStickyPanel;
}

export type TProductStickyPanel = ReturnType<typeof ProductStickyPanelClassCreator>;

export type TProductStickyPanelInstance = InstanceType<TProductStickyPanel>;

export default ProductStickyPanelClassCreator;
